/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';
const { apiFetch } = window.wp;

const { state } = store( 'novisind-membership-form', {
	state: {
	},
	actions: {
		fieldChanged(e) {
			const context = getContext();
            const { ref } = getElement();
            context.fields[e.target.name].input = e.target.value;
            context.fields[e.target.name].empty = (e.target.value.length > 0) ? false : true;
            context.isValid = !Object.keys(context.fields).some((el) => context.fields[el].empty == true);
        },
        submit(e) {
			const context = getContext();
            if (e.preventDefault) e.preventDefault();
            apiFetch( {
                path: 'novisind-membership-form/v1/application',
                method: 'POST',
                data: {
                    name: context.fields.name.input,
                    surname: context.fields.surname.input,
                    oib: context.fields.oib.input,
                    birthday: context.fields.birthday.input,
                    address: context.fields.address.input,
                    place: context.fields.place.input,
                    mail: context.fields.mail.input,
                    phone: context.fields.phone.input,
                    employer: context.fields.employer.input,
                    message: context.fields.message.input,
                },
            } ).then( ( res ) => {
                Object.keys(context.fields).forEach(
                    (f) => { context.fields[f].error = false; } );
                try {
                    let body = JSON.parse(res.body);
                    if (Object.prototype.hasOwnProperty.call(body, "data")) {
                        Object.keys(body.data).forEach((field) => {
                            context.fields[field].error = true;
                            context.fields[field].error_msg = body.data[field][0].message;
                            //body.data[field].forEach((e) => e.message).join("\n");
                        })
                    } else {
                        console.log(body);
                        context.submit = true;
                    }
                }
                catch(err) {
                    context.isValid = false;
                    context.error_msg = "Error connecting to the server";
                    console.log(err);
                }
            } );
        },
    reset(e) {
	    const context = getContext();
        document.getElementById("novisind-form").reset();
        context.submit = false;
        Object.keys(context.fields).forEach(
            (f) => { context.fields[f].error = false; } );
        },
	},
	callbacks: {
	},
} );
